import React from 'react'
import Link from 'gatsby-link'
import cx from 'classnames';
import Header from "./Header";
import Menu from "./Menu";
import throttle from "lodash/throttle"
class Navigation extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuActive: false,
            isScrolled: false,
        };
        this.handleScroll = this.handleScroll.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        //this.changeRoute = this.toggleMenu.bind(this);
    }
    componentDidMount() {
        window.addEventListener('scroll', throttle(this.handleScroll, 150));
    }
    handleScroll(event) {
        const vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        if (window.pageYOffset > vh - 55) {
            this.setState({ isScrolled: true });
        } else {
            this.setState({ isScrolled: false });
        }
    }
    toggleMenu() {
        this.setState({ menuActive: !this.state.menuActive })
    }
    render() {
        return (
            <div>
                <Header className={this.props.className} toggleMenu={this.toggleMenu} menuActive={this.state.menuActive} scrolled={this.state.isScrolled}></Header>
                <Menu toggleMenu={this.toggleMenu} active={this.state.menuActive}></Menu>
            </div>

        );
    }

}
export default Navigation


// WEBPACK FOOTER //
// ./src/components/Navigation/Navigation.js